module.exports = "/_next/static/images/858291b7c588f01a0fdfac618b3e1ad5-image-right-xs.jpg.webp";